// Indian currency formatting utilities

export const formatIndianNumber = (num) => {
  if (num === null || num === undefined || isNaN(num)) return '₹ 0';
  
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
  
  return formatter.format(num);
};

export const formatLakhs = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '₹ 0 L';
  const lakhs = amount / 100000;
  return `₹ ${lakhs.toFixed(2)} L`;
};

export const formatCrores = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '₹ 0 Cr';
  const crores = amount / 10000000;
  return `₹ ${crores.toFixed(2)} Cr`;
};

export const formatSmartCurrency = (amount) => {
  if (amount === null || amount === undefined || isNaN(amount)) return '₹ 0';
  
  if (Math.abs(amount) >= 10000000) {
    return formatCrores(amount);
  } else if (Math.abs(amount) >= 100000) {
    return formatLakhs(amount);
  }
  return formatIndianNumber(amount);
};

export const parseIndianNumber = (str) => {
  if (!str) return 0;
  const cleaned = str.replace(/[₹,\s]/g, '');
  return parseFloat(cleaned) || 0;
};
